import { useThemeData } from '@msrceng/theme';
import { metaVulnReportStatus } from '../../api/enum/metaVulnReportStatus';
/**
 * Makes the style for the status tag based on the status string.
 *
 * `statuses` line up with "status" variations defined in ResearcherPortal-Api:
 *  https://msrceng.visualstudio.com/Workflows/_git/ResearcherPortal-Api?path=%2Fsrc%2FMicrosoft.Msrc.ResearcherPortal.Models%2FEnum%2FReportStatus.cs&_a=contents&version=GBmaster
 */
// eslint-disable-next-line complexity
export const useStatusStyle = (status) => {
    const { theme } = useThemeData();
    const { palette, semanticColors } = theme;
    const { Closed, Complete, CompleteDuplicate, CompleteNA, CompleteResolved, Develop, DevelopDuplicate, Draft, New, NewDuplicate, PreRelease, PreReleaseDuplicate, ReviewRepro, ReviewReproDuplicate, Submitted, Unknown, } = metaVulnReportStatus;
    switch (status) {
        case 'Complete':
        case Complete.displayName:
        case 'CompleteDuplicate':
        case CompleteDuplicate.displayName:
        case 'CompleteNA':
        case CompleteNA.displayName:
        case 'CompleteResolved':
        case CompleteResolved.displayName:
            return {
                background: semanticColors.successBackground,
            };
        case 'Draft':
        case Draft.displayName:
        case 'Submitted':
        case Submitted.displayName:
        case 'Develop':
        case Develop.displayName:
        case 'DevelopDuplicate':
        case DevelopDuplicate.displayName:
        case 'PreRelease':
        case PreRelease.displayName:
        case 'PreReleaseDuplicate':
        case PreReleaseDuplicate.displayName:
        case 'ReviewRepro':
        case ReviewRepro.displayName:
        case 'ReviewReproDuplicate':
        case ReviewReproDuplicate.displayName:
            return {
                background: palette.themeLighter,
            };
        case 'New':
        case New.displayName:
        case 'NewDuplicate':
        case NewDuplicate.displayName:
            return {
                background: semanticColors.disabledBackground,
            };
        case 'Closed':
        case 'Unknown':
        case Closed.displayName:
        case Unknown.displayName:
            return {
                background: semanticColors.warningBackground,
            };
        default:
            return {
                background: semanticColors.disabledBackground,
            };
    }
};
